import React, { useMemo } from "react"
import SubsectionContainer from "./SubsectionContainer"
import { SubsectionContent, SubsectionContentList } from "./SubsectionContent"
import { useCMSReady } from "../../../domain/CMS/useCMSReady"
import { getSortedValuesByKeys } from "../utils/getSortedKeysByValues"

interface InsuranceContentProps {
  insuranceDisplayIds: string[]
  notAcceptingInsurance: boolean
}
export const InsuranceContent: React.FC<InsuranceContentProps> = ({
  insuranceDisplayIds,
  notAcceptingInsurance,
}: InsuranceContentProps) => {
  const { cms: cmsContent, isReady: isCMSReady } = useCMSReady([
    "provider",
    "providerInsuranceCarriers",
  ])
  const providerText = cmsContent.provider
  const insuranceMap = cmsContent.providerInsuranceCarriers

  const sortedInsuranceList = useMemo(() => {
    if (
      !isCMSReady ||
      !providerText ||
      !providerText.insurancePublicProfileSectionWithInsurance ||
      !insuranceMap
    ) {
      return []
    }

    return getSortedValuesByKeys(insuranceDisplayIds, insuranceMap)
  }, [isCMSReady, providerText, insuranceMap, insuranceDisplayIds])

  return (
    <SubsectionContainer>
      <SubsectionContent
        title={
          notAcceptingInsurance
            ? providerText?.insurancePublicProfileSectionWithoutInsurance
            : providerText?.insurancePublicProfileSectionWithInsurance
        }
      >
        <SubsectionContentList listItems={sortedInsuranceList} />
      </SubsectionContent>
    </SubsectionContainer>
  )
}
